import { lazy } from 'react'
import { Route, RouteProps, Routes } from 'react-router-dom'
import LoaderPage from 'components/ui/feedback/LoaderPage'

const DebtorsListPage = lazy(() => import('pages/debtors/page'))

const DebtorsRoutes: React.FunctionComponent<RouteProps> = () => {
  return (
    <Routes>
      <Route path="/" element={<LoaderPage content={<DebtorsListPage />} />} />
    </Routes>
  )
}

export default DebtorsRoutes
